import clsx from 'clsx'
import Container from '../../components/layout/Container'
import { StoryBlock } from '@/src/@types/statamic'
import Bard from '@/src/components/bard/Bard'
import Picture from '@/src/components/elements/Picture'
import Title from '@/src/components/elements/Title'

export function getTitle({ story_parts }: StoryBlock) {
  return story_parts[0].title
}

export default function Component({ story_parts }: StoryBlock) {
  return (
    <Container>
      <div className="grid grid-cols-1 gap-20 md:grid-cols-2 md:gap-24">
        {story_parts.map((story_part, index) => (
          <div className="grid grid-cols-subgrid gap-10 md:col-span-2 md:items-center md:gap-14">
            <div className="aspect-w-1 aspect-h-1">
              <Picture
                priority
                {...story_part.image}
                fill
                className={clsx('rounded-xl object-cover', {
                  'hidden md:block': story_part.image_mobile,
                })}
              />
              {story_part.image_mobile && (
                <Picture
                  priority
                  {...story_part.image_mobile}
                  fill
                  className="rounded-xl object-cover md:hidden"
                />
              )}
            </div>
            <div
              className={clsx({
                '-order-1 md:order-1': index % 2 !== 0,
                '-order-1': index % 2 === 0,
              })}
            >
              {story_part.subtitle && (
                <p className="mb-4 font-bold md:text-xl">
                  {story_part.subtitle}
                </p>
              )}
              <Title style={2}>{story_part.title}</Title>
              <Bard className="mt-4" content={story_part.text} fullWidth />
            </div>
          </div>
        ))}
      </div>
    </Container>
  )
}
